import React from 'react';

//Assets
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CourseExIconBlue, CourseHostedIconBlue, CourseLiveIconBlue } from '../../../../static';

const ACCENT = '#FF0F51';

export const BadgeSubs = styled.div`
  color: ${ACCENT};
  border-radius: 8px;
  margin-left: 8px;
  font-size: 14px;
  padding: 2px;
`;

const TopData = ({ course }) => {
  const userData = useSelector((state) => state.profile_data);

  const packageSub = userData?.mes_subscription ?? '';

  const mesxGrantedCourse = packageSub?.mesx_granted_course_id ?? [];

  const isUsingSubs = mesxGrantedCourse?.includes(course?.id);

  const type = {
    external: (
      <>
        <CourseExIconBlue />
        <p className="course-card__type ml-2">External</p>
      </>
    ),
    live: (
      <>
        <CourseLiveIconBlue /> <p className="course-card__type ml-2">Live</p>
      </>
    ),
    hosted: (
      <>
        <CourseHostedIconBlue />
        <p className="course-card__type ml-2">Self-Paced</p>
        {course?.progress_indicator === '100.00%' &&
        course?.is_qna_required &&
        course?.is_qna_enabled ? (
          course?.course_qna_attend ? (
            ''
          ) : (
            <div className="ml-auto course-card__qna__status">
              <p>Selesaikan live QnA</p>
            </div>
          )
        ) : (
          ''
        )}
      </>
    ),
  };
  return (
    <>
      <div className="d-flex align-items-center">
        {type[course?.type]}

        {isUsingSubs && (
          <BadgeSubs>
            <span className="">
              Subscription |{' '}
              {packageSub?.remaining_days > 0
                ? `${packageSub?.remaining_days} Hari Tersisa`
                : 'Langganan sudah berakhir'}
            </span>
          </BadgeSubs>
        )}
      </div>
      <h2 className="course-card__course-name">{course?.name}</h2>
      <h3 className="course-card__instructor-name">{course?.instructor?.fullname}</h3>
    </>
  );
};

export default TopData;
